// App-side delegate for `@heidi/commerce/data`.
// Resolves `hasUser` for the package hook.
import { GET_CREDIT_ALLOWANCE } from '@heidi/commerce/contracts';
import {
  getCurrentCreditAllowance,
  invalidateCreditAllowance as invalidateCreditAllowanceCore,
  useQueryCreditAllowance as useQueryCreditAllowanceCore,
} from '@heidi/commerce/data';

import { useQueryUser } from '@heidi/workspace/data';

export { GET_CREDIT_ALLOWANCE, getCurrentCreditAllowance };

export function useQueryCreditAllowance(enabled = true) {
  const { data: user } = useQueryUser();

  return useQueryCreditAllowanceCore({
    hasUser: !!user,
    enabled,
  });
}

export const invalidateCreditAllowance = () => invalidateCreditAllowanceCore();
